module.exports = __webpack_public_path__ + "media/spring.303037e1.mp3";